import React from 'react';
import { Divider } from '@chakra-ui/react'
import { trackEvent } from 'utils';

const defaultQuery = {
  q: '',
  city: '',
  ft: '',
  pp: '',
  price: '',
  outdoor: true,
  outdoor_only: false,
  big: false,
  over: false,
  over_only: false,
  prmo: false,
  prnew: false
};

const RecommendationBlock = ({ handleSelect }) => {
  const handleRecommendationClick = (searchParam, type) => {
    trackEvent({ 
      category: 'GamesList-Recommendation', 
      action: 'Click', 
      label: type 
    });
    handleSelect({ ...defaultQuery, ...searchParam }, type);
  };

  return (
    <div>
      <Divider />
      <h5 className='my-2 mx-auto text-center text-lg font-bold'>
        您可能感興趣的熱門分類：
      </h5>
      <div className='w-full mt-0 mx-auto mb-3 grid grid-cols-2 md:grid-cols-4 justify-center gap-3 text-center font-bold'>
        <div 
          className='pt-20 md:pt-24 px-6 md:px-9 pb-4 bg-[50%_20%] md:bg-[50%_25%] bg-[rgba(38,96,171,0.1)] md:bg-[rgba(38,96,171,0.4)] hover:bg-[rgba(38,96,171,0.1)] bg-no-repeat  border border-[rgba(38,96,171,0.7)] cursor-pointer
            bg-[url("/img/themonth_focus.png")] md:bg-[url("/img/themonth.png")] hover:bg-[url("/img/themonth_focus.png")]'
          onClick={() => handleRecommendationClick({ prmo: true }, '本月推薦')}
        >
          <span>本月推薦</span>
        </div>

        <div 
          className='pt-20 md:pt-24 px-6 md:px-9 pb-4 bg-[50%_20%] md:bg-[50%_25%] bg-[rgba(38,96,171,0.1)] md:bg-[rgba(38,96,171,0.4)] hover:bg-[rgba(38,96,171,0.1)] bg-no-repeat  border border-[rgba(38,96,171,0.7)] cursor-pointer
            bg-[url("/img/new_focus.png")] md:bg-[url("/img/new.png")] hover:bg-[url("/img/new_focus.png")]'
          onClick={() => handleRecommendationClick({ prnew: true }, '近期新作')}
        >
          <span>近期新作</span>
        </div>

        <div 
          className='pt-20 md:pt-24 px-6 md:px-9 pb-4 bg-[50%_20%] md:bg-[50%_25%] bg-[rgba(38,96,171,0.1)] md:bg-[rgba(38,96,171,0.4)] hover:bg-[rgba(38,96,171,0.1)] bg-no-repeat  border border-[rgba(38,96,171,0.7)] cursor-pointer
            bg-[url("/img/outdoor_focus.png")] md:bg-[url("/img/outdoor.png")] hover:bg-[url("/img/outdoor_focus.png")]'
          onClick={() => handleRecommendationClick({ outdoor_only: true }, '實境解謎')}
        >
          <span>實境解謎</span>
        </div>

        <div 
          className='pt-20 md:pt-24 px-6 md:px-9 pb-4 bg-[50%_20%] md:bg-[50%_25%] bg-[rgba(38,96,171,0.1)] md:bg-[rgba(38,96,171,0.4)] hover:bg-[rgba(38,96,171,0.1)] bg-no-repeat  border border-[rgba(38,96,171,0.7)] cursor-pointer
            bg-[url("/img/fall_focus.png")] md:bg-[url("/img/fall.png")] hover:bg-[url("/img/fall_focus.png")]'
          onClick={() => handleRecommendationClick({ q: '近期謝幕' }, '近期謝幕')}
        >
          <span>近期謝幕</span>
        </div>
      </div>
    </div>
  );
}
export default RecommendationBlock;